import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import classNames from "classnames";
import { Pagination } from "antd";
import { safetyGasApi } from "@/apis";
import { Input } from "antd";
import emptyPng from "@/images/empty.png";
import storage from "@/utils/store";
import "./index.less";

const { Search } = Input;
const pageSize = 7;

const SafetyGasList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const serchKey = storage.s.get("serchKey");
    if (serchKey) {
      setCurPage(1);
      setSearch(serchKey);
      getGasList("", serchKey, 1);
      storage.s.remove("serchKey");
    }
  }, [location]);

  const [tags, setTags] = useState<string[]>([]);
  const [keywords, setKeyword] = useState<string[]>([]);
  const [tag, setTag] = useState("全部");
  const [search, setSearch] = useState<string>("");
  const [curPage, setCurPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [gasList, setGasList] = useState<SafeyGasList[]>([]);

  useEffect(() => {
    const serchKey = storage.s.get("serchKey");
    safetyGasApi.getSafeyGasTags().then((res) => {
      const tags = res
        ? ["全部", ...res]
        : ["全部", "钢瓶气用气知识", "空分设备", "氧气", "稀有气体", "氮气"];
      setTags(tags);
    });
    safetyGasApi.getSafeyGasWords().then((res) => {
      const wrods = res
        ? res
        : ["钢瓶气用气知识", "空分设备", "氧气", "稀有气体", "氮气"];
      setKeyword(wrods);
    });
    if (serchKey) {
      setCurPage(1);
      setSearch(serchKey);
      getGasList("", serchKey, 1);
      storage.s.remove("serchKey");
    } else {
      getGasList("", "", 1);
    }
  }, []);

  const getGasList = (tag: string, search: string, page: number) => {
    safetyGasApi
      .getSafeyGasList({
        page,
        size: pageSize,
        search,
        tag: tag === "全部" ? "" : tag,
      })
      .then((res) => {
        const { total, records } = res;
        setTotal(total);
        setGasList(records);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeTag = (tag: string) => {
    setTag(tag);
    setCurPage(1);
    getGasList(tag, search, 1);
  };

  const onSearch = (val: string) => {
    setCurPage(1);
    getGasList(tag, val, 1);
  };

  const onChangeSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const onChangeKeywords = (keywords: string) => {
    setSearch(keywords);
    setCurPage(1);
    getGasList(tag, keywords, 1);
  };

  const goDetail = (id: string) => {
    navigate(`/safetyGas/safetyGasDetail/${id}`);
  };

  const handleChangePage = (page: number) => {
    setCurPage(page);
    getGasList(tag, search, page);
  };

  return (
    <div className="max-width list-wrapper">
      <div className="list-container">
        <ul className="tag-container">
          {tags.map((_tag) => (
            <li
              key={_tag}
              className={classNames({ active: _tag === tag })}
              onClick={() => onChangeTag(_tag)}
            >
              {_tag}
            </li>
          ))}
        </ul>
        <div className="content-container">
          {gasList && gasList.length > 0
            ? gasList.map(({ id, title, intro, createTime, url }) => (
                <div
                  className="content-item pointer"
                  onClick={() => goDetail(id)}
                  key={id}
                >
                  <div className="item-left">
                    <h3>{title}</h3>
                    <p>{intro}</p>
                    <span>{createTime}</span>
                  </div>
                  <div className="item-right">
                    <img src={`/crm-venus/v1/venus/images/${url}.id`} alt="" />
                  </div>
                </div>
              ))
            : !loading && <img className="empty" src={emptyPng} alt="" />}
        </div>
        <Pagination
          className="tc"
          current={curPage}
          onChange={handleChangePage}
          defaultPageSize={pageSize}
          total={total}
        />
      </div>
      <div className="side-container">
        <Search
          className="serch-input"
          placeholder="搜索您想找的安全用气知识"
          onSearch={onSearch}
          onChange={onChangeSearch}
          enterButton="搜索"
          allowClear
          value={search}
        />
        <div className="right-item">
          <h3 className="title">
            <span>推荐知识</span>
          </h3>
          {gasList && gasList.length > 0 ? (
            gasList.map((el, index) =>
              index < 3 ? (
                <div
                  className="recommend-item"
                  onClick={() => {
                    goDetail(el.id);
                  }}
                >
                  <h3>{el.title}</h3>
                  <img src={`/crm-venus/v1/venus/images/${el.url}.id`} alt="" />
                  <p>{el.intro}</p>
                </div>
              ) : (
                <></>
              )
            )
          ) : (
            <p>暂无推荐</p>
          )}
        </div>
        <div className="right-item">
          <h3 className="title">
            <span>热门关键词</span>
          </h3>
          <ul className="keywords-list">
            {keywords.map((item) => (
              <li
                onClick={() => {
                  onChangeKeywords(item);
                }}
                key={item}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SafetyGasList;
